export class FilterBaseDto {
    createdAtFrom?: Date;
    createdAtTo?: Date;
    user?: string[] = [];
    dealer?: string[] = [];
    channel?: string[] = [];
    leadType?: string[] = [];
    origin?: string[];
    brand?: string[];
    descriptionModel?: string;
    visitDateFrom?: Date;
    visitDateTo?: Date;
    visitStatus?: string;
    reminderDateFrom?: Date;
    reminderDateTo?: Date;
    updatedAtFrom?: Date;
    updatedAtTo?: Date;
    status?: string[] = [];
    onTrack?: string[] = [];
    hasReminder?: boolean;
    hasVisit?: boolean;
    hasContacted?: boolean;
    transferred?: number;
    customFilters: string[] = [];
    archivedOption: string[] = [];
    archivedComment: string;
    leadContact: string;
    leadContactType: string;
    closedComment?: string;
    closedAtFrom?: Date;
    closedAtTo?: Date;
    notContacted?: boolean;
    onCall?: boolean;
    onPrequalification?: boolean;
    archivedAtFrom?: Date;
    archivedAtTo?: Date;
    postalCode?: string;
    postalCodeType?: string;
    scoring?: {
      scoringNull?: boolean;
      scoringFrom?: number;
      scoringTo?: number;
    };
}
